import {AuditInterface} from '@spa/api';

import {ComponentTypesEnum} from '../../app/shared/enums/common';
import {FilterControlInterface} from '../../app/shared/interfaces';
import {propertyOf, SelectControl} from '../../app/shared/classes';
import {ReportTableActionMenuTypesEnum, ReportTableColumn, ReportTableConfigInterface} from '../../app/shared/components';

import {AuditFiltersInterface} from '../../app/entries/panel/interfaces';

export interface AuditDetailProperty {
    name: string;
    oldValue: any;
    newValue: any;
    modified: boolean;
}

export const ObjectTypeGroups: { key: string, value: string[] }[] = [
    {
        key: 'Details', value: ['Company', 'CompanyAddress', 'CompanyEmployee', 'CompanyTaxDetail', 'Individual',
            'IndividualAddress', 'IndividualIdentityDetail', 'IndividualLegalDeclaration', 'IndividualLocalizedDetail',
            'TradingPlatformSubscriber', 'User']
    },
    {key: 'Accounts', value: ['Account', 'AccountClient', 'AccountGroup']},
    {key: 'Documents', value: ['IndividualDocument', 'CompanyDocument']},
    {
        key: 'AML Risk', value: ['Business', 'IndividualNationality', 'IndividualRisk', 'IndividualSourceOfFund',
            'IndividualSourceOfIncome', 'IndividualTaxDetail']
    },
    {key: 'Bank Accounts', value: ['LinkedAccount']},
    {key: 'Activities', value: ['LoginUserAudit', 'UserToken']},
    {key: 'Payments', value: ['Payment', 'Payment.Recipient#BankDetails', 'Payment.Sender#BankDetails', 'Payment.Sender#BankDetails']},
    {key: 'Settings', value: ['Role', 'RolePermission', 'UserClaim', 'UserClient', 'UserPermission', 'UserRole']},
];

export const PanelAuditsFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: 'objectTypeGroup',
            placeholder: 'Type',
            controls: [
                new SelectControl({
                    name: propertyOf<AuditFiltersInterface>('objectTypeGroup'),
                    value: null,
                    placeholder: 'Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: ObjectTypeGroups.map(og => ({label: og.key, value: og.key}))
                }),
            ],
            shown: true,
            sortIndex: 1,
        },
        {
            name: 'operationType',
            placeholder: 'Operation',
            controls: [
                new SelectControl({
                    name: propertyOf<AuditFiltersInterface>('operationType'),
                    value: null,
                    placeholder: 'Operation',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {label: 'Create', value: 'create'},
                        {label: 'Update', value: 'update'},
                        {label: 'Delete', value: 'delete'}
                    ]
                }),
            ],
            shown: true,
            sortIndex: 2,
        },
        {
            name: 'madeOnDay',
            placeholder: 'Made On',
            controls: [
                new SelectControl({
                    name: propertyOf<AuditFiltersInterface>('madeOnDay'),
                    value: '',
                    placeholder: 'Made On Day',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    options: []
                }),
            ],
            shown: true,
            sortIndex: 3,
        },
        {
            name: 'madeOnAfter',
            placeholder: 'Made After',
            controls: [
                new SelectControl({
                    name: propertyOf<AuditFiltersInterface>('madeOnAfter'),
                    value: '',
                    placeholder: 'Made After',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    options: []
                }),
            ],
            shown: false,
            sortIndex: 4,
        },
        {
            name: 'madeOnBefore',
            placeholder: 'Made Before',
            controls: [
                new SelectControl({
                    name: propertyOf<AuditFiltersInterface>('madeOnBefore'),
                    value: '',
                    placeholder: 'Made Before',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    options: []
                }),
            ],
            shown: false,
            sortIndex: 5,
        }
    ];
};


export const PanelAuditsDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Application',
            selector: propertyOf<AuditInterface>('application'),
        }),
        new ReportTableColumn({
            label: 'Object Type',
            selector: propertyOf<AuditInterface>('objectType')
        }),
        new ReportTableColumn({
            label: 'Object Id',
            selector: propertyOf<AuditInterface>('object'),
        }),
        new ReportTableColumn({
            label: 'Operation',
            selector: propertyOf<AuditInterface>('operationType')
        }),
        new ReportTableColumn({
            label: 'Date',
            selector: propertyOf<AuditInterface>('madeOn')
        }),
        new ReportTableColumn({
            label: 'IP',
            selector: propertyOf<AuditInterface>('madeFromIPAddress')
        })
    ],
    hiddenColumnIds: [],
    actionMenu: false,
    actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
    actionMenuItems: []
};
